/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_YesInputs */

const en_settings_yes = /** @type {(inputs: Settings_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes`)
};

const de_settings_yes = /** @type {(inputs: Settings_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja`)
};

const fr_settings_yes = /** @type {(inputs: Settings_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui`)
};

const es_settings_yes = /** @type {(inputs: Settings_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí`)
};

const it_settings_yes = /** @type {(inputs: Settings_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì`)
};

const nl_settings_yes = /** @type {(inputs: Settings_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja`)
};

const pl_settings_yes = /** @type {(inputs: Settings_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tak`)
};

const fi_settings_yes = /** @type {(inputs: Settings_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kyllä`)
};

const da_settings_yes = /** @type {(inputs: Settings_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja`)
};

const sv_settings_yes = /** @type {(inputs: Settings_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja`)
};

/**
* | output |
* | --- |
* | "Yes" |
*
* @param {Settings_YesInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_yes = /** @type {((inputs?: Settings_YesInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_YesInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_yes(inputs)
	if (locale === "fr") return fr_settings_yes(inputs)
	if (locale === "es") return es_settings_yes(inputs)
	if (locale === "it") return it_settings_yes(inputs)
	if (locale === "nl") return nl_settings_yes(inputs)
	if (locale === "pl") return pl_settings_yes(inputs)
	if (locale === "fi") return fi_settings_yes(inputs)
	if (locale === "da") return da_settings_yes(inputs)
	if (locale === "sv") return sv_settings_yes(inputs)
	return en_settings_yes(inputs)
});